module.exports = __webpack_public_path__ + "img/mind-of-my-mind.a37cceab.png";